<script setup lang="ts">
import { onMounted, type Ref } from 'vue';
import { WaermeerzeugerWarmwasser, WaermeerzeugerWarmwasserCollection } from '@/models/WaermeerzeugerWarmwasser';
import Column from 'primevue/column';
import { getI18n } from '@/helpers/i18n';
import { useToast } from 'primevue/usetoast';
import { errToToast } from '@/helpers/tools';
import KpBaseGrid from '@/components/KpBaseGrid.vue';
import { useRoute, useRouter } from 'vue-router';
import { buildUrl } from '@/helpers/api';
import { type SortOption, useCollection } from '@/composables/managedCollection';
import { useBrowserSessionValue } from '@/helpers/browser_session';

const router = useRouter();
const route = useRoute();
const toast = useToast();

onMounted(() => {
    if (collection.loading.value !== true) {
        collection.query();
    }
});

const tableSort: Ref<SortOption[]> = useBrowserSessionValue(`eco2stat-${route.fullPath}-tableSort`, [
    { direction: 'asc', property: 'reihenfolge' },
]);
const pageSize: Ref<number> = useBrowserSessionValue(`eco2stat-${route.fullPath}-pageSize`, 100);
const page: Ref<number> = useBrowserSessionValue(`eco2stat-${route.fullPath}-page`, 1);
const { collection } = useCollection(new WaermeerzeugerWarmwasserCollection(), {
    autoload: false,
    tableSort,
    pageSize,
    page,
});

function editRecord(r: WaermeerzeugerWarmwasser) {
    router.push({ name: 'bg_geb_waermeerzeuger_warmwasser_edit', params: { id: r?.id } });
}

async function deleteRecord(r: WaermeerzeugerWarmwasser) {
    if (window.confirm(getI18n().t('sicher_loeschen'))) {
        try {
            await r.destroy();
            await collection.query();
        } catch (e) {
            errToToast(e, toast);
        }
    }
}

function newRecord() {
    router.push({ name: 'bg_geb_waermeerzeuger_warmwasser_edit', params: { id: 'new' } });
}

async function onCsvDownload() {
    const params = collection.queryParams;
    params.output = 'csv';
    const url = buildUrl('/' + collection.getModelClassName() + '/list', params);
    window.open(url, 'csvExport');
}
</script>
<template>
    <div style="height: 100%">
        <KpBaseGrid
            :value="collection.getModels()"
            :title="$t('waermeerzeuger_warmwasser')"
            :loading="collection.loading.value"
            sort-field="reihenfolge"
            state-storage="session"
            :state-key="route.fullPath"
            scrollable
            scroll-height="flex"
            @editrecord="editRecord($event as WaermeerzeugerWarmwasser)"
            @deleterecord="deleteRecord($event as WaermeerzeugerWarmwasser)"
            @new="newRecord"
            @csvdownload="onCsvDownload"
        >
            <Column field="id" sortable :header="$t('id')" style="width: 5rem"></Column>
            <Column field="bezeichnung" sortable :header="$t('bezeichnung')"></Column>
            <Column field="reihenfolge" sortable :header="$t('reihenfolge')" style="width: 5rem"></Column>
        </KpBaseGrid>
    </div>
</template>
